<!--
  This page "merges" Angular and angularJS and both their ng-view and router-outlet.
  We can't use ngIf to "wait" for e.g. accountService to be emitted because ng-view will not work
  if not rendered before the ngRouter kicks in. In stead we need to subscribe to values of e.g. accountService.

  Also, using Angular directive [hidden] for an element with angularJS directive ng-include will not work.
  If initial state is hidden=true the directive will not display when changed to hidden=false. Logic to hide
  the content must then be done inside the angularJS directive/template.

isLoggedIn={{(authJSService$ | async)?.isLoggedIn}}<br/>
loading= {{(authJSService$ | async)?.loading}}<br/>
isLoggedOut= {{(authJSService$ | async)?.isLoggedOut}}<br/>
isLoggingOut= {{(authJSService$ | async)?.isLoggingOut}}<br/>
isLoggedOutAtReload= {{(authJSService$ | async)?.isLoggedOutAtReload}}<br/>
  -->
<div *ngIf="(upgradedProviderService === undefined) || !(upgradedProviderService.initialized)
  || !((authenticate$ | async).isUserAuthenticated) && (authenticate$ | async).loading
           "
     class="appLoader"
     style="margin: 48px auto 0px; width: 100%; text-align: center; position: absolute; z-index: 999">
  <img [hidden]="isInIframe" style="width: 64px" src="img/ajax_loader.gif"/>

  <div [hidden]="!isInIframe && (authenticate$ | async).isUserAuthenticated">
    <img src="/img/loading.gif" alt="loading" />
  </div>
  <!-- TODO: Fix showing error again e.g. if getting version fails? -->
  <div [hidden]="isInIframe" *ngIf="(upgradedProviderService === undefined) || !(upgradedProviderService.initialized)"
       style="font-family: Helvetica Neue,Helvetica,Arial,sans-serif; font-size: 6pt">
    Initializing services...
  </div>
  <div [hidden]="isInIframe" *ngIf="!((authenticate$ | async).isUserAuthenticated) && (authenticate$ | async).loading"
       style="font-family: Helvetica Neue,Helvetica,Arial,sans-serif; font-size: 6pt">
    Authenticating...
  </div>
  <div [hidden]="isInIframe" *ngIf="false"
       style="font-family: Helvetica Neue,Helvetica,Arial,sans-serif; font-size: 6pt">
    Logging out...
  </div>


  <div class="errorLoading"
       style="display: none; background-color: rgba(255, 0, 0, 0.25); border-radius: 2px; margin-top: 15px; margin-right: 10%; margin-left: 10%; line-height: 30px; font-family: 'Play', sans-serif;">
    The server is not ready yet (probably during restart), try again after a while
  </div>
</div>
<div [hidden]="!upgradedProviderService?.initialized"
     class="appBody"
     [ngClass]="{ 'sidebar_open': ((authenticate$ | async).isAdmin) && !isInIframe,  'sidebar_hidden': !((authenticate$ | async).isAdmin) || isInIframe}">

  <div class="reloadBtnWindow" [ngClass]="{'openReload': isPortalVersionChanged$| async}">
    <div>
      <span style="line-height: 35px;">&nbsp;AutoRemind has made some updates. Please reload your browser.</span>
      <button style="float: right;" type="button" class="btn btn-success" (click)="reload()">Reload</button>
    </div>
  </div>

  <div [hidden]="!((authenticate$ | async).isUserAuthenticated) || isInIframe">
    <top-navigation-bar></top-navigation-bar>
  </div>
  <!--div ng-include="'app/reminders/appointments.html'"-->

  <!--ng1-appointments></ng1-appointments-->
  <main
        class="container containerContent" role="main">
    <div id="sidebar-holder" class="side-animation" [hidden]="!((authenticate$ | async).isUserAuthenticated) || isInIframe">
      <side-navigation-bar></side-navigation-bar>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="main_content" [style.padding-top]="isInIframe ? '0' : ''">
          <div [hidden]="!((authenticate$ | async).isUserAuthenticated)">
            <div ng-view>
              <!-- This is where the partial template will be filled in for the selected page -->
            </div>
          </div>

          <router-outlet name ="loginOutlet"></router-outlet>
          <router-outlet [hidden]="!((authenticate$ | async).isUserAuthenticated)"></router-outlet>
          <!-- Putting this after ng-view allows e.g. to display admin user tabs and then user devices component below
          as if it was inside the tab content -->
        </div>
      </div>
    </div>

  </main>
</div>

